import { IKogIcon } from "@/main/@types/interfaceIcons";

export function TransitIcon({ height = "50px", width = "50px", color = "currentColor" }: IKogIcon) {
	return (
		<svg
			version="1.0"
			xmlns="http://www.w3.org/2000/svg"
			width={width}
			height={height}
			viewBox="0 0 549.000000 442.000000"
			preserveAspectRatio="xMidYMid meet"
		>
			<g transform="translate(0.000000,442.000000) scale(0.100000,-0.100000)" fill={color} stroke="none">
				<path
					d="M1093 4276 c-183 -45 -344 -210 -382 -394 -6 -29 -11 -125 -11 -212
          l0 -159 -246 -3 c-245 -3 -246 -3 -265 -27 -24 -30 -24 -42 2 -75 l20 -26 870
          0 c597 0 877 3 890 11 45 23 40 86 -8 108 -16 8 -193 11 -578 11 l-555 0 0
          163 c0 174 9 222 54 299 38 65 93 113 171 150 l70 33 993 3 c1090 3 1039 5
          1149 -58 53 -30 108 -89 138 -150 46 -89 45 -57 45 -1537 l0 -1403 -668 0
          -669 0 -26 67 c-65 166 -192 306 -341 377 -219 106 -443 104 -665 -5 -63 -31
          -103 -61 -167 -123 l-84 -81 0 342 0 343 -65 0 -65 0 0 -597 c0 -471 3 -612
          14 -663 53 -251 237 -455 483 -538 70 -24 92 -26 223 -26 130 0 153 3 217 26
          153 54 273 142 357 262 88 124 129 238 142 400 l7 86 652 0 652 0 8 -91 c24
          -316 210 -560 500 -657 106 -36 273 -42 385 -13 315 79 531 339 548 658 l5
          103 228 0 c125 0 239 4 253 10 15 5 31 21 38 35 10 22 8 30 -9 53 -20 26 -23
          27 -131 30 l-111 3 -3 737 -3 737 -28 60 c-24 52 -83 115 -444 476 -272 273
          -431 426 -462 442 -70 38 -144 47 -403 47 l-238 0 0 158 c0 179 -14 253 -63
          346 -42 81 -137 176 -215 215 -126 64 -79 61 -1167 60 -755 0 -1002 -4 -1042
          -13z m3057 -919 c34 -18 840 -814 840 -829 0 -5 -317 -8 -705 -8 l-705 0 0
          423 c0 233 3 427 7 431 4 4 125 6 268 4 230 -3 264 -5 295 -21z m880 -1657 l0
          -690 -80 0 c-68 0 -82 3 -86 17 -4 10 -27 60 -52 112 -38 79 -60 109 -136 186
          -72 72 -107 99 -167 128 -242 118 -519 102 -739 -41 -30 -20 -85 -67 -122
          -106 l-68 -69 0 577 0 576 725 0 725 0 0 -690z m-3505 -305 c216 -45 399 -209
          458 -412 58 -195 5 -419 -131 -561 -241 -250 -596 -260 -843 -24 -134 127
          -185 259 -176 452 5 126 33 209 103 307 103 144 302 250 474 252 25 0 77 -6
          115 -14z m2810 -11 c171 -44 332 -197 395 -377 27 -78 37 -229 20 -310 -21
          -101 -84 -213 -169 -298 -184 -184 -452 -224 -684 -102 -212 112 -352 389
          -307 608 74 363 392 568 745 479z"
				/>
				<path
					d="M462 2963 c-36 -31 -33 -77 8 -98 25 -13 151 -15 1018 -15 986 0 989
          0 1016 21 31 25 34 61 6 89 -20 20 -33 20 -1024 20 -941 0 -1005 -1 -1024 -17z"
				/>
				<path
					d="M212 2450 c-12 -5 -27 -21 -34 -35 -10 -22 -8 -30 9 -53 l20 -27 872
          -3 c605 -1 878 1 892 9 45 23 40 86 -8 108 -30 14 -1716 14 -1751 1z"
				/>
			</g>
		</svg>
	);
}
